import { RadioField, RadioInput } from '@flos/react-ui';
import type { AttributeChangeProps } from '../../../types';
import { useState } from 'react';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { AreaOfDestination_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { opcInfoAtom } from '../../../../../recoil/atoms/opcInfoAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import useOpcJob from '../../../../../hooks/useOpcJob';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

const ChangeAreaOfDestination = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const { attributeValue } = useRecoilValue(opcInfoAtom);
    const {
        createPolicyChangeWithRenewalDateForOPC,
        withdrawCurrentOPCShoppingBasketIfNotExisting
    } = useOpcJob();
    const getHippoText = useHippoText();
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const [areaOfDestination, setAreaOfDestination] = useState<string>(attributeValue ?? '');
    const isTravelWorldAreaPreviuosly = useRecoilValue(getCoverableInfoSelector).isTravelWorldArea;

    const hippoText = {
        worldWideOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-WORLDWIDE'),
        europeOnlyOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-EUROPE-ONLY')
    };

    const handleAreaOfDestinationChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ): Promise<void> => {
        const { value } = event.target;
        if (isTravelWorldAreaPreviuosly && (value as AreaOfDestination_Top) === 'OnlyEurope') {
            await withdrawCurrentOPCShoppingBasketIfNotExisting();
            await createPolicyChangeWithRenewalDateForOPC();
        }
        updateCoverableAttribute({
            areaOfDestination: value as AreaOfDestination_Top
        });
        setAreaOfDestination(value as AreaOfDestination_Top);
        setIsOpcDataFilled(value !== attributeValue);
    };

    return (
        <div>
            <RadioField
                value={areaOfDestination ?? ''}
                onChange={(event) => {
                    void handleAreaOfDestinationChange(event);
                }}
                disabled={isOpcFetching}
            >
                <RadioInput value="Worldwide" label={hippoText.worldWideOption} />
                <RadioInput value="OnlyEurope" label={hippoText.europeOnlyOption} />
            </RadioField>
        </div>
    );
};

export default ChangeAreaOfDestination;
